import Component from 'vue-class-component';
import {UserApiService} from '@/services/generated/edge/user';
import {RegistrationVue} from '@/registration-vue';
import {SearchResult} from '../../../../mock/api/edge/user/index';
import StatusEnum = SearchResult.StatusEnum;
import {loadSecurityQuestions} from '@/utils';
declare var dataLayer: any;
@Component({template: require('./clubcard-entry.html')})
export class ClubCardEntryPage extends RegistrationVue {

  loading = false;

  name = '';

  mounted() {
    this.$store.state.clubcardNumber = '';

    this.$validator.updateDictionary({
      en: {
        custom: {
          ccnumber: {
            required: 'Please enter your Clubcard number',
            min: 'Clubcard number should be 16 digits',
          },
          name: {
            required: 'Please enter your name as it appears on the card'
          }
        }
      }
    });

    dataLayer.push({
      'event': 'stepLoaded',
      'stepNumber': '2',
      'stepName': 'Enter clubcard details'
    });
  }

  created() {
    this.$validator.extend('berror', {
      getMessage: function(field, params, data) {
        return (data && data.message) || 'Something went wrong';
      },
      validate: function (value) {
        return {
          valid: false,
          data: {
            message: value
          }
        }
      }
    });
  }

  next() {
    this.doIfFormIsValid(() => {
      this.loading = true;

      UserApiService.findUser({
                             email: this.$store.state.email,
                             clubCard: this.$store.state.clubcardNumber.replace(/ /g, ''),
                             name: this.name,
                             banner: ''
                           }).then((searchResult) => {

        switch (searchResult.status) {
          case StatusEnum.REGISTERED:
            this.navigate('registration-error');
            break;
          case StatusEnum.PARTIAL_REGISTERED:
            this.$store.state.isQuickShopper = false;
            this.$store.state.firstName = searchResult.fistName;
            this.$store.state.lastName = searchResult.lastName;
            this.$store.state.presetPhoneNumber = searchResult.phoneNumber;
            this.$store.state.requireTitle = searchResult.requireTitle;

            loadSecurityQuestions(this.$store).then(() => {
              this.navigate('security-entry');
            }).catch(() => {
              this.loading = false;
            });
            break;
          case StatusEnum.NOT_REGISTERED:
            this.loading = false;
            this.alert('We can\'t find your Clubcard. Please check the information you\'ve entered and try again. Or give us a ring on 0800 463 996.');
            break;
          default:
            this.loading = false;
            this.handleApiError(`Unknown status: ${searchResult.status}`);
            break;
        }
      }).catch((error) => {
        this.loading = false;
        this.handleApiError(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/forms/clubcard-entry/clubcard-entry.ts